import { segmentTrackAction } from '../../../../../../../middlewares/segment';
import { Dispatch, ThunkAction } from '../../../../../../../types/actions';

export const onTabExportActive = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        // console.log('segment onTabExportActive');
    };
    return action;
};
